module.exports = __webpack_public_path__ + "static/media/viber.e50eba99.svg";